import script from "./ban-ip-address.vue?vue&type=script&setup=true&lang=js"
export * from "./ban-ip-address.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__